module.exports = __webpack_public_path__ + "static/media/image-video-5.0bbad1ce.png";